import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs'
import workerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'

// pdf.js parses untrusted documents; keeping that work in a worker keeps a
// malformed file from locking the UI thread.
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl

export { pdfjs }
